module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedHeavyItalic.abab8f9.woff";